import { Component, Input, AfterViewInit } from '@angular/core';
import { GaugeCircleChartData } from '../../../../../models/influencer';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';

@Component({
  selector: 'channel-followers',
  templateUrl: './channel-followers.component.html',
  styleUrls: ['./channel-followers.component.scss']
})
export class ChannelFollowersComponent implements AfterViewInit {

  static COMPONENT_NAME = 'ChannelFollowersComponent';
  @Input() channelFollowersData: GaugeCircleChartData[] = [];

  constructor(private pdfService: PdfExportService) { }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(ChannelFollowersComponent.COMPONENT_NAME);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-followers/channel-followers.component.ts